import React from 'react';

import Link, { ILinkProps } from 'components/link';
import { t } from 'state/intl/translations';

export const CCPA_COMPLIANCE = 'ccpa-compliance';

export const CCPAButtonLink: React.FC<ILinkProps> = props => {
  return (
    <Link {...props} onPress={() => window.OneTrust.ToggleInfoDisplay()}>
      {t('CCPADontSellButton')}
    </Link>
  );
};

declare global {
  interface Window {
    OneTrust: {
      ToggleInfoDisplay: () => void;
    };
  }
}
